// extracted by mini-css-extract-plugin
export var externalLink = "_77-0";
export var internalLinkLabel = "_77-1";